var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgContactStatus = function SvgContactStatus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14.789,
    height: 14.709,
    viewBox: "0 0 14.789 14.709",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1193"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20857",
    d: "M18143.295 9952.684a.749.749 0 0 1-.8-.793v-3.349a3.032 3.032 0 0 1 1.754-2.789 4.174 4.174 0 0 1-.158-1.034 3.188 3.188 0 0 1 6.375 0 4.752 4.752 0 0 1-.16 1.034 3.025 3.025 0 0 1 1.75 2.789v3.349a.746.746 0 0 1-.793.793zm.8-4.142v2.552h6.375v-2.552a1.436 1.436 0 0 0-1.117-1.354 3.09 3.09 0 0 1-4.143 0 1.313 1.313 0 0 0-1.116 1.354zm1.594-3.823a1.593 1.593 0 1 0 1.592-1.591 1.6 1.6 0 0 0-1.593 1.591zm6.75-1.887h-.01l-1.883-1.882a.886.886 0 0 1 1.254-1.253l1.254 1.253 2.719-2.721a.888.888 0 0 1 1.254 1.258l-3.34 3.341a.875.875 0 0 1-.629.26.863.863 0 0 1-.62-.256z",
    transform: "translate(-18142.498 -9937.975)",
    style: {
      fill: "#c4c4c4"
    }
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgContactStatus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/contactStatus.c653a3c2.svg";
export { ForwardRef as ReactComponent };